import React from "react";
import { RadioGroupField } from "@syos-music/form";
import { InstrumentTypeSelectField } from "@syos-music/instruments";
import { Product } from "@syos-music/products";

import { Grid } from "@mui/material";

const { ReedsBoxStrengthSelectField } = Product.displayModes.reedsBox;

export default function OptionsFields({ isOrderPaid, cartItem, name }) {
  const { instrument } = cartItem.product.defaultOptions;

  return (
    <Grid container alignItems="flex-end">
      <Grid item xs={12} md={4}>
        <InstrumentTypeSelectField
          name={`${name}.instrumentType`}
          instrument={instrument}
        />
      </Grid>

      <Grid item xs={12} md={4}>
        <ReedsBoxStrengthSelectField name={`${name}.strength`} />
      </Grid>

      <Grid item xs={12} md={4}>
        <RadioGroupField
          label="Taille de boîte"
          name={`${name}.quantity`}
          disabled={isOrderPaid}
          row
          parse={(v) => parseInt(v, 10)}
        >
          <RadioGroupField.Option value={5} label="5" />
          <RadioGroupField.Option value={10} label="10" />
        </RadioGroupField>
      </Grid>
    </Grid>
  );
}
